import { Record, List } from 'immutable';
import moment from 'moment';
import { construct, fields, resolve, resolveAll } from '../helpers/LinkMapper';
import ReservationPassenger from './ReservationRequestPassenger';
import ReservationJourney from './ReservationJourney';
import { API_ISO_FORMAT } from '../constants/AppConstants';


const ReservationRequest = new Record({
    passengers: new List(),
    outwardJourney: new ReservationJourney(),
    returnJourney: new ReservationJourney(),
    bikes: 0,
    requestSeats: false,
});

Object.assign(ReservationRequest.prototype, {
    toJSON() {
        return {
            passengers: this.passengers.toJS(),
            outwardJourney: this.outwardJourney.toJSON(),
            returnJourney: this.returnJourney.toJSON(),
            bikes: this.bikes,
        };
    },

    formatForAPI() {
        const formatDateTime = (dt) => dt ? moment(dt).format(API_ISO_FORMAT) : undefined;

        const transformJourney = (journey) => ({
            origin: {
                nlc: journey.origin.nlc,
                name: journey.origin.name,
            },
            destination: {
                nlc: journey.destination.nlc,
                name: journey.destination.name,
            },
            ticketTypeCode: journey.ticketType,
            routeCode: journey.routeCode,
            reserve: true,
            legs: journey.legs.map(leg => ({
                date: moment(leg.date).format('YYYY-MM-DD'),
                retailServiceId: leg.retailServiceId,
                origin: {
                    nlc: leg.origin.nlc,
                    name: leg.origin.name,
                },
                destination: {
                    nlc: leg.destination.nlc,
                    name: leg.destination.name,
                },
                departure: formatDateTime(leg.departure),
                arrival: formatDateTime(leg.arrival),
                reservable: leg.reservable,
                operator: leg.operator,
                mode: leg.mode,
            })),
        });

        const formatted = {
            passengers: this.passengers.map(p => ({
                statusCode: p.statusCode,
                attributes: p.attributes,
            })),
            ...(this.bikes > 0 ? { bikes: this.bikes } : {}),
        };

        if (this.outwardJourney) {
            formatted.outwardJourney = transformJourney(this.outwardJourney);
        }

        if (this.returnJourney && this.returnJourney.legs.size > 0) {
            formatted.returnJourney = transformJourney(this.returnJourney);
        }

        return formatted;
    }
});

ReservationRequest.fromJSON = function(json) {
    return construct(ReservationRequest, json, {
        passengers: resolveAll.as(ReservationPassenger),
        outwardJourney: resolve.as(ReservationJourney),
        returnJourney: resolve.as(ReservationJourney),
        bikes: fields.number,
        requestSeats: fields.boolean,
    });
};

export default ReservationRequest;
